export const enum ServiceSettingsQA {
    ColorPalettes = 'color-palettes',
    AddPaletteButton = 'add-palette-btn',
}

export const enum PaletteEditorQA {
    PaletteNameInput = 'palette-name',
    RemoveColorButton = 'remove-color-btn',
    AddColorButton = 'add-color-btn',
    ColorTextInput = 'color-input',
    ApplyButton = 'apply-btn',
}
